export const BASE_URL = '/api'
export const OK_RET = 200
export const OK_STATUS = 200
export const ILLEGAL_RET = 1300
export const PAYMENT_COMPLETED_RET = 101
export const NATIVE_CALLBACK = '__native_handler__'
export const PAYMENT_ICONS_MAPPING = {
  // 支付宝
  1: {
    icon: 'alipay',
    name: '支付宝',
  },
  // 微信
  2: {
    icon: 'wechat',
    name: '微信',
  },
  // 余额
  3: {
    icon: 'balance',
    name: '余额',
  },
  // 云闪付
  4: {
    icon: 'yunquickpass',
    name: '云闪付',
  },
  // 企业账期
  5: {
    icon: 'ep-monthly',
    name: '月结账户',
  },
  // 招行
  6: {
    icon: 'zh',
    name: '招商银行',
  },
  // 搬家钱包
  7: {
    icon: 'balance',
    name: '搬家钱包',
  },
  8: {
    icon: 'jdpay',
    name: '京东支付',
  },
  9: {
    icon: 'adyen',
    name: 'adyen',
  },
  10: {
    icon: 'paytm',
    name: 'paytm',
  },
  11: {
    icon: '2c2p',
    name: '2c2p',
  },
  12: {
    icon: 'gcash',
    name: 'gcash',
  },
  13: {
    icon: 'alipay',
    name: '支付宝',
  },
  14: {
    icon: 'ep-monthly',
    name: '月结账户',
  },
  15: {
    icon: 'tappay',
    name: 'tappay',
  },
  16: {
    icon: 'line',
    name: 'linepay',
  },
  17: {
    icon: 'jkopay',
    name: 'jkopay',
  },
  18: {
    icon: 'payme',
    name: 'payme',
  },
  20: {
    icon: 'momo',
    name: 'momo',
  },
}
export const PAYMENT_WITH_SDK = [901, 1500]

export default {
  BASE_URL,
  OK_RET,
  OK_STATUS,
  ILLEGAL_RET,
  PAYMENT_COMPLETED_RET,
  NATIVE_CALLBACK,
  PAYMENT_ICONS_MAPPING,
}
